import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rota-olusturuldu',
  templateUrl: './rota-olusturuldu.component.html',
  styleUrls: ['./rota-olusturuldu.component.css']
})
export class RotaOlusturulduComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }
  goToLojistik() {
    this.router.navigate(['lojistik']);
  }
  newLojistik() {
    this.router.navigate(['rota-olustur'], { queryParams: { id: '0' } });
  }
}
